import React, { createContext, useState, useRef, useEffect } from 'react';
import { logListenedTime } from '../../utils/contentConsumption';
import { pushEvent, EVENTS } from '../../utils/dataLayer';
export const AudioPlayerContext = createContext();
// Percent milestones reported as audio_progress.
const PROGRESS_MILESTONES = [25, 50, 75];
export const AudioPlayerProvider = ({ children }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTrack, setCurrentTrack] = useState(null);
  const [currentEpisodeNumber, setCurrentEpisodeNumber] = useState(null);
  const [totalEpisodeCount, setTotatlEpisodeCount] = useState(null);
  const [episodeThumb, setEpisodeThumbnail] = useState(null);
  const [showPlayer, setShowPlayer] = useState(false);
  const [duration, setDuration] = useState(0);
  const [audioTracks, setAudioTracks] = useState([]);
  const [currentTrackLanguage, setCurrentTrackLaguage] = useState([]);
  const [currentTime, setCurrentTime] = useState(0);
  let time = 0.00;
  const audioRef = useRef(new Audio());
  const intervalIdRef = useRef(null);
  // Episode currently loaded into the audio element. A ref, not a local, so the
  // logging interval still sees it after a re-render.
  const episodeIdRef = useRef(null);
  // Last position (whole seconds) already reported, to skip duplicate rows.
  const lastLoggedTimeRef = useRef(-1);
  const LISTENED_LOG_INTERVAL_MS = 10000;
  // Which audio_progress milestones this episode already sent.
  const sentMilestonesRef = useRef(new Set());
  // Episode fields every audio_* event carries. A ref so audio element listeners
  // registered once on mount still see the current episode.
  const trackInfoRef = useRef(null);
  const pushAudioEvent = (event, extra = {}) => {
    if (!trackInfoRef.current) return;
    const audio = audioRef.current;
    pushEvent(event, {
      ...trackInfoRef.current,
      position_sec: Math.round(audio.currentTime || 0),
      duration_sec: Math.round(audio.duration || 0) || null,
      ...extra,
    });
  };
  useEffect(() => {
    const audio = audioRef.current;
        // console.log('audio==>'+audio);
    const updateCurrentTime = () => {
      setCurrentTime(audio.currentTime);
      if (!(audio.duration > 0)) return;
      const percent = (audio.currentTime / audio.duration) * 100;
      PROGRESS_MILESTONES.forEach((m) => {
        if (percent >= m && !sentMilestonesRef.current.has(m)) {
          sentMilestonesRef.current.add(m);
          pushAudioEvent(EVENTS.AUDIO_PROGRESS, { percent: m });
        }
      });
    };
    const updateDuration = () => setDuration(audio.duration);
    const onEnded = () => pushAudioEvent(EVENTS.AUDIO_COMPLETE);
    audio.addEventListener('timeupdate', updateCurrentTime);
    audio.addEventListener('loadedmetadata', updateDuration);
    audio.addEventListener('ended', onEnded);
    // A tab close mid-episode would otherwise lose everything since the last tick.
    const flushOnExit = () => sendListenedLog({ keepalive: true });
    window.addEventListener('pagehide', flushOnExit);
    return () => {
      audio.removeEventListener('timeupdate', updateCurrentTime);
      audio.removeEventListener('loadedmetadata', updateDuration);
      audio.removeEventListener('ended', onEnded);
      window.removeEventListener('pagehide', flushOnExit);
      stopListenedLogging();
    };
  }, []);
  // Reports how far the user has listened into the current episode.
  const sendListenedLog = ({ keepalive = false } = {}) => {
    const episode_id = episodeIdRef.current;
    const playedTime = audioRef.current.currentTime;
    if (episode_id == null || !(playedTime > 0)) return;
    // Nothing new since the last tick (paused, buffering, backgrounded tab).
    if (Math.floor(playedTime) === lastLoggedTimeRef.current) return;
    lastLoggedTimeRef.current = Math.floor(playedTime);
    logListenedTime(episode_id, playedTime, { keepalive });
  };
  const startListenedLogging = () => {
    stopListenedLogging();
    intervalIdRef.current = setInterval(sendListenedLog, LISTENED_LOG_INTERVAL_MS);
    console.log(`⏱️ Listened logging started for episode ${episodeIdRef.current} (every ${LISTENED_LOG_INTERVAL_MS / 1000}s)`);
  };
  const stopListenedLogging = () => {
    if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
      intervalIdRef.current = null;
      console.log(`⏹️ Listened logging stopped for episode ${episodeIdRef.current}`);
    }
  };
  //old
 /*  const playTrack = (tracks, current_episode, index, thumb, played_time, language_id) => {
    // console.log(tracks, current_episode, index, thumb, played_time, language_id);
    let languageIDArr = []
    episodeId = tracks[index].id;
    setEpisodeThumbnail(thumb)
    setCurrentTrack(tracks[index]);
    setAudioTracks(tracks)
    setIsPlaying(true);
    setShowPlayer(true);
    setCurrentTrackLaguage(tracks[index].available_lang);
    setCurrentEpisodeNumber(current_episode)
    setTotatlEpisodeCount(tracks.length)
    if (language_id == 0) {
      console.log(tracks[index].media_urls);
      console.log('if===> ', tracks[index].media_urls[0].audio_file_url);
      audioRef.current.src = tracks[index].media_urls[0].audio_file_url;
    }
    else {
      console.log(tracks[index].media_urls);
      let lastId = tracks[index].media_urls.length;
      for (let i = 0; i < tracks[index].media_urls.length; i++) {
        languageIDArr.push(tracks[index].media_urls[i].language_id)
        const element = tracks[index].media_urls[i];
        if (element.language_id == language_id)
          audioRef.current.src = tracks[index].media_urls[i].audio_file_url;
      }
      // console.log(languageIDArr.includes(parseInt(language_id)));
      if (!languageIDArr.includes(parseInt(language_id))) {
        console.log(languageIDArr);
        console.log('inside ....');
        audioRef.current.src = tracks[index].media_urls[lastId - 1].audio_file_url;
      }
    }
    // console.log(played_time, tracks[index].played_time);
  //  if (played_time > tracks[index].played_time)
  //     time = played_time
  //   else
  //     time = tracks[index].played_time != null ? tracks[index].played_time : played_time 
    time = 0.00; //update 21-july-2025
    seekTo(time)
    audioRef.current.volume = localStorage.getItem('dastaan__player_volume') != null ? localStorage.getItem('dastaan__player_volume') : 1;
    audioRef.current.playbackRate = localStorage.getItem('dastaan__player_speed') != null ? localStorage.getItem('dastaan__player_speed') : 1;
    audioRef.current.play();
    // if (intervalIdRef.current) {
    //   stopInterval(); // Stop the current interval if it exists
    // } else {
    //   startInterval(); // Start a new interval if none exists
    // } 
  }; */
  //new updated 
  const playTrack = (tracks, current_episode, index, thumb, played_time, language_id) => {
  let languageIDArr = [];
  // Report the outgoing episode before its position is overwritten by the new one.
  sendListenedLog();
  stopListenedLogging();
  episodeIdRef.current = tracks[index].id;
  lastLoggedTimeRef.current = -1;
  sentMilestonesRef.current = new Set();
  trackInfoRef.current = {
    episode_id: tracks[index].id != null ? String(tracks[index].id) : null,
    episode_title: tracks[index].title || null,
    episode_number: current_episode,
    audio_file_id: localStorage.getItem('audio_file_id') || null,
    total_episodes: tracks.length,
    language_id,
  };
  pushAudioEvent(EVENTS.AUDIO_PLAY, { position_sec: 0, duration_sec: null });
  setEpisodeThumbnail(thumb);
  setCurrentTrack(tracks[index]);
  setAudioTracks(tracks);
  setIsPlaying(true);
  setShowPlayer(true);
  setCurrentTime(0);
  setDuration(0);
  setCurrentTrackLaguage(tracks[index].available_lang);
  setCurrentEpisodeNumber(current_episode);
  setTotatlEpisodeCount(tracks.length);
  // Select appropriate audio URL
  let selectedAudioURL = '';
  if (language_id === 0) {
    selectedAudioURL = tracks[index].media_urls[0].audio_file_url;
  } else {
    let found = false;
    const mediaUrls = tracks[index].media_urls;
    for (let i = 0; i < mediaUrls.length; i++) {
      const element = mediaUrls[i];
      languageIDArr.push(element.language_id);
      if (element.language_id === language_id) {
        selectedAudioURL = element.audio_file_url;
        found = true;
        break;
      }
    }
    if (!found) {
      selectedAudioURL = mediaUrls[mediaUrls.length - 1].audio_file_url;
    }
  }
  // Prepare and load audio
  const audio = audioRef.current;
  audio.pause(); // Stop current audio
  audio.src = selectedAudioURL;
  audio.load(); // Load new audio source
  // Wait for metadata to update duration and seekbar correctly
  const onLoadedMetadata = () => {
    time = 0.00; // <-- Updated: always start at beginning
    seekTo(time); // Set currentTime after metadata is loaded
    audio.volume = parseFloat(localStorage.getItem('dastaan__player_volume') || 1);
    audio.playbackRate = parseFloat(localStorage.getItem('dastaan__player_speed') || 1);
    audio.play(); // Start playback
    startListenedLogging();
    audio.removeEventListener('loadedmetadata', onLoadedMetadata); // Clean up
  };
  audio.addEventListener('loadedmetadata', onLoadedMetadata);
};
  const setTrack = (current_track, index, language_id) => {
    // console.log(`current_track==> ${nextTrack},index===>${index}`);
    setCurrentTrackLaguage([])
    console.log(`✅ Next / Previous track Index :::: ${index} ||  current Track :::: ${current_track}`);
    playTrack(audioTracks, current_track, index, episodeThumb, 0, language_id)
  }
  const pauseTrack = (status) => {
    if (status === true) {
      setIsPlaying(false);
      audioRef.current.pause();
      sendListenedLog();
      stopListenedLogging();
      pushAudioEvent(EVENTS.AUDIO_PAUSE);
      console.log('⏸️ Track paused !');
    }
    else {
      setIsPlaying(true);
      audioRef.current.play();
      startListenedLogging();
      pushAudioEvent(EVENTS.AUDIO_RESUME);
      console.log('▶️ 🎧 Track playing ....');
    }
  };
  const seekTo = (time) => {
    // time = 0.00
    audioRef.current.currentTime = time;
    audioRef.current.play();
  };
  const closePlayer = () => {
    console.log('close player button cliked :)');
    setIsPlaying(false);
    audioRef.current.pause();
    sendListenedLog();
    stopListenedLogging();
    pushAudioEvent(EVENTS.AUDIO_CLOSE);
    trackInfoRef.current = null;
    episodeIdRef.current = null;
    setShowPlayer(false)
    setCurrentTrack(null);
    setCurrentEpisodeNumber(null);
  }
  return (
    <AudioPlayerContext.Provider value={{
      setTrack,
      isPlaying, currentTrack, playTrack, pauseTrack, audioRef, showPlayer, duration, currentTime, seekTo, episodeThumb,
      currentEpisodeNumber,
      totalEpisodeCount,
      audioTracks,
      currentTrackLanguage,
      closePlayer
    }}>
      {children}
    </AudioPlayerContext.Provider>
  );
};
